import { render, staticRenderFns } from "./ModalityCreate.vue?vue&type=template&id=180bcd98&"
import script from "./ModalityCreate.js?vue&type=script&lang=js&"
export * from "./ModalityCreate.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports